import React from 'react';
import { SvgIcon } from '@mui/material';

const DropDownArrow = ({ ...props }) => (
    <SvgIcon {...props} width="32px" height="32px" viewBox="0 0 32 32" version="1.1">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g
                transform="translate(-1392.000000, -2276.000000)"
                fill="currentColor"
                fillRule="nonzero"
            >
                <g transform="translate(48.000000, 2212.000000)">
                    <g id="Large-Down-Icon" transform="translate(1344.000000, 64.000000)">
                        <g id="1.-Icon/Arrow/Down/Large">
                            <path
                                d="M10.6326618,30.0003 C11.0158831,30.0003 11.3981116,29.8533 11.6880096,29.5573 L22.9999885,18.0743 L11.5430606,6.4423 C10.9652502,5.8563 10.0240745,5.8513 9.44030733,6.4353 C8.85654012,7.0173 8.85256891,7.9663 9.43236492,8.5543 L18.8093739,18.0743 L9.57731392,27.4463 C8.99851072,28.0333 9.00148912,28.9823 9.58426353,29.5643 C9.87515433,29.8553 10.2534117,30.0003 10.6326618,30.0003"
                                id="↳Select-Color"
                                transform="translate(15.999988, 18.000169) rotate(90.000000) translate(-15.999988, -18.000169) "
                            />
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </SvgIcon>
);
export default DropDownArrow;
